import ImdfPage from "../../../design-system/pages/imdf/index"

export default ImdfPage
